import * as React from 'react';
import * as _ from 'lodash';
import { Icon } from '@ane/ui-components';
import { getTheme, mergeStyleSets } from '@ane/ui-components/lib/Styling';
import { Spinner } from '@ane/ui-components';
import LinkRouteAction from '@ane/ui-components/lib/components/LinkRouteAction/LinkRouteAction';
import { useProgressionScorecardContext } from '../Provider';
import { getAnalysisGroupAsync } from '../../../../selectors';
import { useSelector } from 'react-redux';
export var ValidationRequestStatus;
(function (ValidationRequestStatus) {
    ValidationRequestStatus["Completed"] = "Passed";
    ValidationRequestStatus["Pending"] = "Pending";
    ValidationRequestStatus["Failed"] = "Failed";
    ValidationRequestStatus["NotRequired"] = "NotRequired";
})(ValidationRequestStatus || (ValidationRequestStatus = {}));
const classNames = mergeStyleSets({
    success: [{ color: getTheme().palette.green }],
    failure: [{ color: getTheme().palette.red }],
});
export const ValidationStatus = ({ analysisGroupId, analysisTemplateId }) => {
    const rolloutId = useProgressionScorecardContext((context) => context.featureId);
    const openErrorPanel = useProgressionScorecardContext((context) => context.openErrorPanel);
    const { data: analysisGroupData } = useSelector((state) => getAnalysisGroupAsync(state, { rolloutId }));
    const analysisGroup = _.find(analysisGroupData === null || analysisGroupData === void 0 ? void 0 : analysisGroupData.value, (analysisGroup) => analysisGroup.id === analysisGroupId);
    const analysisTemplate = _.find(analysisGroup === null || analysisGroup === void 0 ? void 0 : analysisGroup.analysisList, (template) => template.id === analysisTemplateId);
    const { status = '' } = analysisTemplate !== null && analysisTemplate !== void 0 ? analysisTemplate : {};
    const _getIconProps = () => {
        switch (status) {
            case ValidationRequestStatus.Completed:
                return { ariaLabel: `${status}`, iconName: 'CompletedSolid', className: classNames.success };
            case ValidationRequestStatus.Pending:
                return { ariaLabel: `${status}`, iconName: 'Running' };
            case ValidationRequestStatus.Failed:
                return { ariaLabel: `${status}`, iconName: 'Blocked2Solid', className: classNames.failure };
            default:
                return null;
        }
    };
    const _getStatusText = () => {
        switch (status) {
            case ValidationRequestStatus.Completed:
                return 'Validation succeeded';
            case ValidationRequestStatus.Pending:
                return 'Validation in progress';
            case ValidationRequestStatus.NotRequired:
                return 'Not required';
            default:
                return null;
        }
    };
    const iconProps = _getIconProps();
    const statusText = _getStatusText();
    return (React.createElement("span", null,
        status !== ValidationRequestStatus.Pending && iconProps && (React.createElement(Icon, Object.assign({}, iconProps, { styles: { root: { marginRight: '8px' } } }))),
        status === ValidationRequestStatus.Pending && iconProps && (React.createElement(Spinner, Object.assign({}, iconProps, { size: 0, styles: { root: { marginRight: '8px', display: 'inline-block' } } }))),
        status === ValidationRequestStatus.Failed && (React.createElement(LinkRouteAction, { text: "Validation failed", onClick: (ev) => {
                openErrorPanel(analysisGroupId, analysisTemplateId);
                ev.stopPropagation();
            } })),
        statusText));
};

//# sourceMappingURL=ValidationStatus.js.map
